import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export function AgeVerificationWarning() {
  const { user } = useAuth();
  const [isDismissed, setIsDismissed] = useState(false);

  const ageConfidence = user?.maybeAgeInfoFE?.confidence?.toLowerCase() || 'none';
  const hasAgeDeclaration = !!user?.maybeAgeInfoFE?.maybeDeclared;

  // Only show warning for NONE confidence (missing age data) AND no age declaration
  // Do NOT show for low confidence (inconsistent) to avoid blocking UI
  // If user has declared their age, don't show the warning even if confidence is not set
  if (ageConfidence !== 'none' || hasAgeDeclaration || isDismissed) {
    return null;
  }

  return (
    <div className="relative w-full bg-gradient-to-r from-amber-600 to-orange-600 shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-2.5">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-4 h-4 text-white flex-shrink-0" />
          <div className="flex-1">
            <p className="text-white text-xs leading-relaxed">
              <span className="font-semibold">Age verification required:</span> You may experience longer wait times. Please complete your age group selection in settings.
            </p>
          </div>
          <button
            onClick={() => setIsDismissed(true)}
            className="text-white/80 hover:text-white transition-colors flex-shrink-0"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
